import { render, staticRenderFns } from "./review-generic.vue?vue&type=template&id=44a0c9ec"
import script from "./review-generic.vue?vue&type=script&lang=js"
export * from "./review-generic.vue?vue&type=script&lang=js"
import style0 from "./review-generic.vue?vue&type=style&index=0&id=44a0c9ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports